<template>
  <div>
    <Table :columns="columns" :data="index" :is-row-clickable="true" @row-click="redirectToPlanSalePage">
      <!-- Sales Channel Information -->
      <template #salesChannel="{ row }">
        <TableLink :to="`/stores/${row.storeId}`" class="font-semibold" data-test="store-link">
          {{ row.store.salesChannel }}
        </TableLink>
        <div class="mt-1 flex space-x-2">
          <FieldSpan :value="row.chargedBy" :style-to-add="chargedByStyle(row)" />
          <FieldSpan
            v-if="row.seller"
            :value="row.seller.firstName + ' ' + row.seller.lastName"
            style-to-add="text-yellow-500 bg-yellow-100 border border-yellow-300"
          />
          <FieldSpan :value="row.status" :style-to-add="statusListStyle(row)" translation-prefix="planSale.status" />
        </div>
        <div class="flex flex-col md:hidden">
          <span>{{ row.customer.email }}</span>
          <span>
            {{ row.title }} à
            <span class="font-bold">
              {{ formatPrice(row.price) }}
            </span>
          </span>
          <span class="md:hidden block" v-if="row.products?.length > 0">
            {{ row.products[0].title }} à {{ formatPrice(row.products[0].price) }}
          </span>
          <span>{{ row.id }} - {{ row.purchaseDate }}</span>
          <span class="font-light italic" v-if="isCancelled(row)">Résilié le {{ row.cancellationDate }}</span>
        </div>
      </template>

      <!-- Customer Information -->
      <template #customer="{ row }">
        <div class="flex flex-col">
          <span class="font-semibold">
            {{ row.customer.firstName }}
            {{ row.customer.lastName }}
          </span>
          <span>{{ row.customer.email }}</span>
        </div>
      </template>

      <!-- Plan Information -->
      <template #plan="{ row }">
        <div class="flex flex-col">
          <span>
            <span class="font-semibold">{{ row.title }}</span>
            à
            <span class="font-medium">{{ formatPrice(row.price) }}{{ by_month(row) }}</span>
          </span>
          <span class="font-light">{{ row.category }}</span>
          <span class="font-light">{{ row.id }} - {{ row.purchaseDate }}</span>
          <span v-if="row.orderReferenceId" class="font-light">Numéro de commande : {{ row.orderReferenceId }}</span>
          <span class="font-light italic" v-if="isCancelled(row)">Résilié le {{ row.cancellationDate }}</span>
        </div>
      </template>

      <!-- Product Information -->
      <template #product="{ row }">
        <div v-if="row.products?.length > 0">
          <span class="font-semibold">{{ truncatedTitle(row.products[0].title) }}</span>
          <div class="flex">
            <span class="font-light italic mr-2">
              {{ formatPrice(row.products[0].price) }}
            </span>
          </div>
        </div>
      </template>
    </Table>
    <Pagination :currentPage="currentPage" :totalPages="totalPages" :totalCount="totalCount" @changePage="updatePage" />
  </div>
</template>

<script>
// UI Components and Utilities
import { Pagination, Table, FieldSpan, formatPrice, TableLink } from "@estaly/ui";

// Vuex
import { mapState, mapGetters } from "vuex";

// i18n
import { useI18n } from "vue-i18n";

export default {
  name: "PlanSalesContent",

  components: {
    FieldSpan,
    Table,
    Pagination,
    TableLink,
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    currentPage: {
      type: Number,
      required: true,
    },
  },

  computed: {
    // Vuex state
    ...mapState("planSales", ["index", "totalCount", "totalPages"]),
    ...mapGetters("planSales", ["isCancelled", "statusListStyle", "chargedByStyle"]),

    // Table configuration
    columns() {
      return [
        {
          label: "Magasin",
          field: "salesChannel",
          slot: "salesChannel",
        },
        {
          label: "Contrat",
          field: "id",
          slot: "plan",
        },
        {
          label: "Produit",
          field: "product",
          slot: "product",
        },
        {
          label: "Client",
          field: "customer",
          slot: "customer",
        },
      ];
    },
  },

  methods: {
    // External utilities
    formatPrice,

    truncatedTitle(title) {
      return title.length > 40 ? title.slice(0, 40) + "…" : title;
    },

    // Event handlers
    updatePage(newPage) {
      this.$emit("updatePage", newPage);
    },

    redirectToPlanSalePage(planSale) {
      return this.$router.push(`/plan-sales/${planSale.friendlyId}`);
    },

    by_month(planSale) {
      return planSale.monthlyBilling ? "/mois" : "";
    },
  },
};
</script>

<i18n src="./PlanSalesContent.i18n.json"></i18n>
